import {ContentEditableMarkdownEditor, createContentEditableMarkdownEditor} from '@frontapp/editor-html';

import {isValidMention} from '../../../../helpers/models/commentHelpers';
import {EmojiMap} from '../../../../services/emojis/emojis';
import {trackCharacterShortcutReplaceEvent} from '../../../../services/tracking/composer';
import {createCharacterShortcutPlugin} from '../../../common/editor/plugins/text/charShortcutPlugin';
import {createEmojiPlugin, EmojiPluginRenderModesEnum} from '../../../common/editor/plugins/text/emojiPlugin';
import {createMentionPlugin} from '../../../common/editor/plugins/text/mentionPlugin';
import {trackFormattingEventForEditorInteraction} from './commentComposerFormattingTracking';

export function createCommentComposerEditor(
  initialMarkdown = '',
  getConversationId: () => number | undefined,
  mentionClassName: string,
  getMentionableAliases: () => ReadonlySet<string>,
  shouldLineBreakOnShiftEnter: () => boolean,
  emojiValidationMap: EmojiMap,
  hasListServiceV2: boolean,
): ContentEditableMarkdownEditor {
  const editor = createContentEditableMarkdownEditor({
    plugins: [
      createEmojiPlugin({
        renderMode: EmojiPluginRenderModesEnum.SHORTCODE,
        shouldReplaceEmoticons: true,
        emojiValidationMap,
      }),
      createCharacterShortcutPlugin({
        onReplace: trackCharacterShortcutReplaceEvent,
      }),
      createMentionPlugin({
        className: mentionClassName,
        isValidMention: (mention) => isValidMention(getMentionableAliases(), mention),
      }),
    ],
    onInteraction: (event) => trackFormattingEventForEditorInteraction(getConversationId(), event),
    shouldLineBreakOnShiftEnter,
    shouldNativeDelete: true,
    hasListServiceV2,
  });

  editor.services.markdown.setMarkdown(initialMarkdown);
  return editor;
}
